import { tabsSlice, videoHeightSlice } from './slices';
import type { DrawCentreOptions, DrawCentreState } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: DrawCentreProvider,
  useStore: useDrawCentreStore,
  createStore: createDrawCentreStore,
} = zustandStoreFactory<DrawCentreState>(
  (...args) => ({
    ...tabsSlice(...args),
    ...videoHeightSlice(...args),
  }),
  'DrawCentre',
);

export const { OptionsProvider: DrawCentreOptionsProvider, useOptions: useDrawCentreOptions } =
  getOptionsProvider<DrawCentreOptions>();
